/**
 *  Page
 */
export default class Page {
    /**
     * constructor
     * @param {object} extended
     */
    constructor(extended) {
        if (extended === null) { extended = {}; }
        this.extended = extended;
        this.isIn = false;

        this.config = $.extend({
            type: 'page',
            component: '',
        }, this.extended);
    }

    /**
     * Check if a page is active
     *
     * @param {String} slug - class to check against
     *
     * @returns {boolean}
     */
    is(slug) {
        return $('body').hasClass(`${ this.config.type }-${ this.config.component }${ slug }`);
    }

    /**
     * Check if current page matches an array of slugs
     *
     * @param {Array} slugs
     *
     * @returns {boolean}
     */
    in(slugs = []) {
        // Reset the bool
        this.isIn = false;

        // Check each and return as the normal function
        slugs.forEach((slug) => {
            if (this.is(slug)) { return this.isIn = true; }
        });

        return this.isIn;
    }

    /**
     * Get a segment of the uri
     *
     * @param {Number} id - the segment to match
     *
     * @returns {Boolean|String}
     */
    segment(id) {
        // Get segments
        const segments = window.location.pathname.split('/');
        // Return segment is set
        if (segments[id] !== null) {
            return segments[id];
        }

        return false;
    }

    /**
     * Check if a specific segment matches a string
     *
     * @param {Number} id - the segment to match
     * @param {String} match - class to match against
     *
     * @returns {boolean}
     */
    segmentMatch(id, match) {
        // Shorthand segment check
        return (this.segment(id) === match);
    }
}
